export default class InfoBar extends React.Component {
  constructor(props) {
    super(props);
    this.getDateTime = this.getDateTime.bind(this);
    this.formatChangeLog = this.formatChangeLog.bind(this);
    this.formatObjectInfo = this.formatObjectInfo.bind(this);
    this.dataForObjectOrSource = this.dataForObjectOrSource.bind(this);
    this.slideInfoBar = this.slideInfoBar.bind(this);
    this.domId = "infobar";
    this.dataI18nKeys = {
      new_value: "source-new-value",
      old_value: "source-old-value",
      fields: "source-fields",
      event: "source-event",
      time: "source-time",
      date: "source-date",
      change_log: "source-change-log",
      edit: "source-edit",
      delete: "source-delete",
      info: "source-info",
      reference: "source-reference",
      about_the_object: "source-about-the-object",
      source_data: "source-source-data",
      object_data: "source-object-data",
      nothing_to_show: "source-nothing-to-show",
      save_as_favorite: "source-save-as-favorite",
      saved_as_favorite: "source-saved-as-favorite",
    };
    this.state = {
      column: null,
      data: [],
      changeLogData: [],
      direction: null,
    }
  }
 

  componentDidMount() {
    this.slideInfoBar();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.props.changeLog && this.props.changeLog != this.state.data){
      let changeLogDataArr = [];
      for(var i=0; i<this.props.changeLog.length; i++){
        if(i==1){
          continue;
        }else{ 
        if(this.props.changeLog[i].fields && this.props.changeLog[i].fields.length > 0){
          for(var j=0; j < this.props.changeLog[i].fields.length; j++){  
            if(this.props.changeLog[i].fields[j].name == 'Highlight Height'){
              continue;
            }else{
            changeLogDataArr.push({
              "date" : this.getDateTime(this.props.changeLog[i].firedAt, "d"),
              "time" : this.getDateTime(this.props.changeLog[i].firedAt, "t"),
              "event" : this.props.changeLog[i].command,
              "fields" : this.props.changeLog[i].fields[j].name,
              "old_value" : this.props.changeLog[i].fields[j].old_value,
              "new_value" : this.props.changeLog[i].fields[j].new_value
            });
            }
          }
        }else{
          changeLogDataArr.push({
            "date" : this.getDateTime(this.props.changeLog[i].firedAt, "d"),
            "time" : this.getDateTime(this.props.changeLog[i].firedAt, "t"),
            "event" : this.props.changeLog[i].command,
            "fields" : '-',
            "old_value" : '-',
            "new_value" : '-'
          });
        }
      }
      }
      this.setState({
        data: this.props.changeLog,
        changeLogData: changeLogDataArr
      });
    }
    this.slideInfoBar();
  }

  slideInfoBar() {
    if (this.props.selectedObject) {
      $("#" + this.domId).slideDown("slow");
    } else {
      $("#" + this.domId).slideUp("slow");
    }
  }

  getDateTime(timestamp, format = "dt") {
    var d = new Date(timestamp);
    var addLeadingZero = (val) => (val < 10 ? "0" : "") + val;
    if (/^d$/.test(format)) {
      return (
        d.getFullYear() +
        "-" +
        addLeadingZero(d.getMonth() + 1) +
        "-" +
        addLeadingZero(d.getDate())
      );
    } else if (/^t$/.test(format)) {
      return (
        addLeadingZero(d.getHours()) +
        ":" +
        addLeadingZero(d.getMinutes()) +
        ":" +
        addLeadingZero(d.getSeconds())
      );
    }
    return (
      d.getFullYear() +
      "-" +
      addLeadingZero(d.getMonth() + 1) +
      "-" +
      addLeadingZero(d.getDate()) +
      " " +
      addLeadingZero(d.getHours()) +
      ":" +
      addLeadingZero(d.getMinutes())
    );
  }


  handleSort (clickedColumn) {
    const { column, data, direction, changeLogData } = this.state;
    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        changeLogData: _.orderBy(changeLogData, [log => log[clickedColumn].toString().toLowerCase()], ['asc']),
        direction: 'ascending',
      }, () => { this.props.showModal("", this.formatChangeLog())})
    }else{
      this.setState({
        changeLogData: _.orderBy(changeLogData, [log => log[clickedColumn].toString().toLowerCase()], [direction === 'ascending'? 'desc' : 'asc']),
        direction: direction === 'ascending' ? 'descending' : 'ascending',
      }, () => { this.props.showModal("", this.formatChangeLog()) });
    }    
  }
  formatChangeLog() {
    var changeLog = this.props.changeLog;
    const { column, data, direction, changeLogData } = this.state; 
    
    if (changeLog.length === 0) {
      return (
        <h1 id="no-log-message">
          {globalFunctions.getTranslatedMessage(
            this.dataI18nKeys.nothing_to_show,
            "Nothing to show"
          )}
        </h1>
      );
    }
    return (
      <div>
        <table className="ui sortable celled table change-log">
          <thead>
            <tr>
              <th 
              className={column === 'date' ? "sorted "+direction : null}
              sorted={column === 'date' ? direction : null}
              onClick={(e) => this.handleSort('date')}>
                <span data-i18n={this.dataI18nKeys.date}>Date</span>
              </th>
              <th
              className={column === 'time' ? "sorted "+direction : null}
              sorted={column === 'time' ? direction : null}
              onClick={(e) => this.handleSort('time')}>
                <span data-i18n={this.dataI18nKeys.time}>Time (UTC)</span>
              </th>
              <th
              className={column === 'event' ? "sorted "+direction : null}
              sorted={column === 'event' ? direction : null}
              onClick={(e) => this.handleSort('event')}>
                <span data-i18n={this.dataI18nKeys.event}>Event</span>
              </th>
              <th
              className={column === 'fields' ? "sorted "+direction : null}
              sorted={column === 'fields' ? direction : null}
              onClick={(e) => this.handleSort('fields')}>
                <span data-i18n={this.dataI18nKeys.fields}>Fields</span>
              </th>
              <th 
              className={column === 'old_value' ? "width-20 sorted "+direction : "width-20"}
              sorted={column === 'old_value' ? direction : null}
              onClick={(e) => this.handleSort('old_value')}>
                <span data-i18n={this.dataI18nKeys.old_value}>Old value</span>
              </th>
              <th 
              className={column === 'new_value' ? "width-20 sorted "+direction : "width-20"}
              sorted={column === 'new_value' ? direction : null}
              onClick={(e) => this.handleSort('new_value')}>
                <span data-i18n={this.dataI18nKeys.new_value}>New value</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {changeLogData.map((log, index) => {
              // if (log.fields && log.fields.length > 0) {
              //   return log.fields.map((field, i) => {
              //     if (typeof field === "undefined") {
              //       return null;
              //     }
              //     return (
              //       <tr key={"index-" + index + "-" + i}>
              //         <td>{this.getDateTime(log.firedAt, "d")}</td>
              //         <td>{this.getDateTime(log.firedAt, "t")}</td>
              //         <td>{log.command}</td>
              //         <td>{field.name}</td>
              //         <td style={{textTransform:'capitalize'}}>
              //           {field.old_value && String(field.old_value).length > 0
              //             ? field.old_value
              //             : "-"}
              //         </td>
              //         <td style={{textTransform:'capitalize'}}>
              //           {field.new_value && String(field.new_value).length > 0
              //             ? field.new_value
              //             : "-"}
              //         </td>
              //       </tr>
              //     );
              //   });
              // }
              // return (
              //   <tr key={"index-" + index}>
              //     <td>{this.getDateTime(log.firedAt, "d")}</td>
              //     <td>{this.getDateTime(log.firedAt, "t")}</td>
              //     <td>{log.command}</td>
              //     <td>-</td>
              //     <td>-</td>
              //     <td>-</td>
              //   </tr>
              // );
              return (
                <tr key={"index-" + index}>
                  <td>{log.date}</td>
                  <td>{log.time}</td>
                  <td>{log.event}</td>
                  <td>{log.fields}</td>
                  <td>{log.old_value}</td>
                  <td>{log.new_value}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  dataForObjectOrSource() {
    if (this.props.objectInfo.type === globalFunctions.objectTypes.OBJECT) {
      return {
        obj1: this.props.objectInfo.actualObjectData,
        obj2: this.props.objectInfo.objectData,
      };
    }
    if (this.props.objectInfo.type === globalFunctions.objectTypes.SOURCE) {
      return {
        obj1: this.props.objectInfo.sourceData,
        obj2: this.props.objectInfo.reference,
      };
    }
    return { obj1: {}, obj2: {} };
  }

  generateTinyURL(id) {
    globalFunctions.displayTinyUrl(site_url + "/" + id);
  }

  formatObjectInfo() {
    const object = this.props.objectInfo;
    const message1 =
      this.props.objectInfo.type === globalFunctions.objectTypes.OBJECT
        ? globalFunctions.getTranslatedMessage(
            this.dataI18nKeys.about_the_object,
            "About the object"
          )
        : globalFunctions.getTranslatedMessage(
            this.dataI18nKeys.source_data,
            "Source data"
          );
    const message2 =
      this.props.objectInfo.type === globalFunctions.objectTypes.OBJECT
        ? globalFunctions.getTranslatedMessage(
            this.dataI18nKeys.object_data,
            "Object data"
          )
        : globalFunctions.getTranslatedMessage(
            this.dataI18nKeys.reference,
            "Reference"
          );
    let { obj1, obj2 } = this.dataForObjectOrSource();
    let isUser = _.get(obj1, "Is User", null);
    if (isUser) {
      obj1 = _.omit(obj1, "Is User");
      obj1 = Object.assign({ "Your View?": isUser }, obj1);
    }

    return (
      <div className="ui container" id="infobar-object-info-modal">
        <div className="ui stackable grid">
          <div className="row">
            {object.type === globalFunctions.objectTypes.REFERENCE && (
              <div className="sixteen wide column">
                <div className="record-table">
                  <div className="record">
                    <span className="key">View ID:</span>
                    <span className="value">{object.referenceData.viewId}</span>
                  </div>
                  <div className="record">
                    <span className="key">Title:</span>
                    <span className="value">{object.referenceData.title}</span>
                  </div>
                  <div className="record">
                    <span className="key">Value: </span>
                    <span className="value">{object.referenceData.value}</span>
                  </div>
                </div>
              </div>
            )}
            {_.get(this.props.selectedObject, "type") === "SOURCE" ? (
              <div className="notesWrapper">
                <div className="notesAuthorHeader">Notes from the author:</div>
                <div className="notes">{obj1.Notes || obj2.Notes || ""}</div>
              </div>
            ) : (
              <React.Fragment>
                {object.type !== globalFunctions.objectTypes.REFERENCE && (
                  <div className="eight wide column">
                    <h4 className="infobar-object-info-header">{message1}</h4>
                    <div className="record-table">
                      {Object.keys(obj1).map((key) => (
                        <div key={key} className="record">
                          <span className="key"> {key} </span>
                          <span className="value"> { key == 'Is Published' ? obj1[key] == 'Published' ?  <button className="ui button green" id="publish-object">{obj1[key]}</button> : <button className="ui button blue" id="publish-object">{obj1[key]}</button> : obj1[key]} </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {object.type !== globalFunctions.objectTypes.REFERENCE && (
                  <div className="eight wide column">
                    <h4 className="infobar-object-info-header">{message2}</h4>
                    <div className="record-table">
                      {Object.keys(obj2).map((key) => (
                        <div key={key} className="record">
                          <span className="key"> {key} </span>
                          <span className="value"> {obj2[key]} </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const viewId =
      this.props.selectedObject && this.props.selectedObject.viewId;
    const id = this.props.selectedObject && this.props.selectedObject.id;
    const type = this.props.selectedObject && this.props.selectedObject.type;
    const disabled =
      this.props.selectedObject &&
      this.props.selectedObject.type === globalFunctions.objectTypes.SOURCE &&
      !this.props.selectedObject.hasNotes;
    const disabledChangeLog = this.props.changeLog.length ? false : true;
    const display = "hide";
    const i18nStrChangeLog = globalFunctions.getTranslatedMessage(
      this.dataI18nKeys.change_log,
      "Change Log"
    );
    const i18nStrChangeLogHeader = globalFunctions.getTranslatedMessage(
      this.dataI18nKeys.change_log,
      "Change Log"
    ) + ' - '+ viewId;
    const i18nStrInfo =
      type === "SOURCE"
        ? "Notes"
        : globalFunctions.getTranslatedMessage(this.dataI18nKeys.info, "Info");
    const i18nStrHeader =
      type === "SOURCE" ? (
        <div className="notesModalHeader ui grid">
          <p className="six wide column" >Notes</p>
          <p className="ten wide column" >{viewId}</p>
        </div>
      ) : (
        globalFunctions.getTranslatedMessage(this.dataI18nKeys.info, "Info")
      );
    const isOwner = this.props.isOwner;
    const isLoggedIn = this.props.isLoggedIn;
    const isSavedAsFavorite = this.props.isSavedAsFavorite;
    var isProtected = false;

    if (_.get(this.props.selectedObject, "isProtected", "no") === "yes") {
      isProtected = true;
    }
    
    return (
      <div
        id={this.domId}
        className={display}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          id="selected-object-id_Edit"
          className={
            (this.props.hideEdit || isProtected === true ? "hide" : "show",
            (_.get(this.props.selectedObject, "pageSectionSelected") ||
              _.get(this.props.selectedObject, "type") === "SOURCE" ||
              _.get(this.props.selectedObject, "type") === "OBJECT") &&
            isProtected === false &&
            isOwner && isLoggedIn
              ? "show"
              : "hide")
          }
          onClick={this.props.fetchEditForm}
        >
          <span className="text">
            {globalFunctions.getTranslatedMessage(
              this.dataI18nKeys.edit,
              "Edit"
            )}
          </span>
          <i className="edit icon"></i>
        </div>
        <div
          id="selected-object-id_Delete"
          className={isOwner && isLoggedIn ? "show" : "hide"}
          onClick={this.props.performDelete}
        >
          <span className="text">
            {globalFunctions.getTranslatedMessage(
              this.dataI18nKeys.delete,
              "Delete"
            )}
          </span>
          <i className="trash icon"></i>
        </div>
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/web/js/InfoBar.js